module.exports = __webpack_public_path__ + "static/media/46.c3e0b5d5.jpg";